import RichTextEditor from 'react-rte'
import { isEmpty } from 'util/validation/Util'

export const isRichTextValueEmpty = (value: any) => {
  const richTextValue = RichTextEditor.createValueFromString(value, 'html')
  let text = ''
  const textBlocks = JSON.parse(richTextValue.toString('raw')).blocks
  textBlocks.forEach((e) => (text += e.text?.toString()))
  return isEmpty(value) || isEmpty(text) || !/\S/.test(text)
}

export const createRichTextEditor = (value: string | null | undefined): RichTextEditor =>
  value ? RichTextEditor.createValueFromString(value, 'html') : RichTextEditor.createEmptyValue()
